import GroupSearchPage from "./components/GroupSearchPage.vue";
import GroupTimetablePage from "./components/GroupTimetablePage.vue";

export default {
  routes: [
    {
      path: "/",
      component: GroupSearchPage,
      name: "TimetableGroupSearchPage",
    },
    {
      path: "/group/:id",
      component: GroupTimetablePage,
      props: true,
      name: "TimetableGroupTimetablePage",
    },
  ],
};
